<div class="container" [class.tablet]="isTablet" [class.mobile]="isMobile">
  <img src="../../assets/Prices/prices_pic.jpg" alt="prices" class="picture" />
  <h2>{{ "Tarifs" | translate }}</h2>
  <div class="content">
    <div class="line">
      <p class="desc">
        <span>{{ "Haut" | translate }}</span>
        <span
          >(1 {{ "chambre" | translate }}, 2+ {{ "personnes" | translate }},
          50{{ "m²" | translate }})</span
        >
      </p>
      <div class="prices">
        <p class="price low">€ 100 / {{ "nuit" | translate }}</p>
        <p class="price middle">€ 120 / {{ "nuit" | translate }}</p>
        <p class="price high">€ 130 / {{ "nuit" | translate }}</p>
      </div>
    </div>
    <div class="line">
      <p class="desc">
        <span>{{ "Bas" | translate }}</span>
        <span
          >(1 {{ "chambre" | translate }}, 2+ {{ "personnes" | translate }},
          75{{ "m²" | translate }})</span
        >
      </p>
      <div class="prices">
        <p class="price low">€ 110 / {{ "nuit" | translate }}</p>
        <p class="price middle">€ 130 / {{ "nuit" | translate }}</p>
        <p class="price high">€ 140 / {{ "nuit" | translate }}</p>
      </div>
    </div>
    <div class="line">
      <p class="desc">
        <span>{{ "Bas" | translate }} +</span>
        <span
          >(2 {{ "chambres" | translate }}, 4+ {{ "personnes" | translate }},
          100{{ "m²" | translate }})</span
        >
      </p>
      <div class="prices">
        <p class="price low">€ 120 / {{ "nuit" | translate }}</p>
        <p class="price middle">€ 150 / {{ "nuit" | translate }}</p>
        <p class="price high">€ 165 / {{ "nuit" | translate }}</p>
      </div>
    </div>
    <div class="line">
      <p class="desc">
        <span>{{ "Villa entière" | translate }}</span>
        <span
          >(3 {{ "chambres" | translate }}, 6+ {{ "personnes" | translate }},
          150{{ "m²" | translate }})</span
        >
      </p>
      <div class="prices">
        <p class="price low">€ 170 / {{ "nuit" | translate }}</p>
        <p class="price middle">€ 210 / {{ "nuit" | translate }}</p>
        <p class="price high">€ 230 / {{ "nuit" | translate }}</p>
      </div>
    </div>
    <div class="line legend">
      <div class="low">{{ "Novembre à Mars" | translate }}</div>
      <div class="middle">
        {{ "Avril" | translate }}, {{ "Mai" | translate }},
        {{ "Juin" | translate }}, {{ "Septembre" | translate }}
        {{ "et" | translate }} {{ "Octobre" | translate }}
      </div>
      <div class="high">
        {{ "Juillet" | translate }} {{ "et" | translate }}
        {{ "Aout" | translate }}
      </div>
    </div>
  </div>

  <div class="footer">
    <div class="section">
      <div>
        <b>{{ "Supplément par séjour de moins de 4 nuits" | translate }}</b>
      </div>
      <div>60€ {{ "pour une location partielle" | translate }}</div>
      <div>100€ {{ "pour une location entière" | translate }}</div>
    </div>
    <div class="section">
      <div>
        <b>{{ "Caution" | translate }}</b>
      </div>
      <div>500€</div>
      <div>
        {{
          "Prix charges comprises sous réserve d'une utilisation en bon père de famille"
            | translate
        }}
      </div>
    </div>
  </div>
</div>
